<template>
    <div class="export-pickup clearfix" style="position: relative">
        <Form ref="dataForm" :model="formData" :labelWidth="120">
            <FormItem label="Carton label barcode">
                <Input
                    type="textarea"
                    v-model="barcode"
                    :rows="5"
                    :filterable="true"
                    :clearable="true"
                    :placeholder="
                        $t('erp.b2c.barcode_per_line', {
                            defaultValue: '支持输入多个，一行一个barcode',
                        })
                    "
                />
            </FormItem>
        </Form>
        <div class="pull-right">
            <Button type="primary" @click="submit">{{
                $t("global.common.export", { defaultValue: "导出" })
            }}</Button>
            <Button class="margin-left-15" @click="$emit('on-close')">{{
                $t("global.common.operation_cancel", { defaultValue: "取消" })
            }}</Button>
        </div>
    </div>
</template>

<script>
export default {
    props: ["orderData"],
    data() {
        return {
            formData: {},
            id: this.orderData.id,
            barcode: "",
        };
    },
    watch: {},
    computed: {
        required() {
            return [
                {
                    required: true,
                    message: this.$t("global.common.required", {
                        defaultValue: "此项不能为空，请填写",
                    }),
                },
            ];
        },
    },
    methods: {
        submit() {
            let flag = true;
            this.$refs.dataForm.validate((valid) => {
                return (flag = valid);
            });
            if (!flag) return;
            this.formData.headId = this.id;
            let cartonNo;
            if (this.barcode) {
                cartonNo = this.barcode.replace(/\n/g, ",");
            }
            delete this.barcode;
            this.handleWebfs(
                process.env.VUE_APP_APIURL_BOSS +
                    "/api/v2/DeliverOrder/PoShipmentCartonItem/amzccExport",
                {
                    contextId: global.SYSID,
                    ...this.formData,
                    cartonNoStr: cartonNo,
                },
                {
                    executor: "request",
                    download: true,
                }
            );
            this.$emit("on-close");
        },
    },
};
</script>

<style></style>
